import React from 'react';
import { baseSet } from '@utils/common';

const safeSet = (object, path, value) => {
  return object == null ? object : baseSet(object, path, value)
}

function defineGetter (component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: () => {
      if (getter === 'props') {
        return component.props
      }
      return {
        ...component.props,
        ...component.state
      }
    }
  })
}

export default class CommonComponent extends React.Component {

  constructor(props) {
    super(props);
    defineGetter(this, 'data', 'state');
  }

  setData = (obj, callback) => {
    const state = Object.assign({}, this.state)
    Object.keys(obj).forEach(key => {
      safeSet(state, key, obj[key])
    })
    Object.assign(this.state, state)
    this.setState(state)
    setTimeout(() => {
      typeof callback == 'function' && callback()
    }, 0)
  }
}


// WEBPACK FOOTER //
// ./src/common/CommonComponent.jsx